import React from 'react';
import { NavLink, useParams } from 'react-router-dom';
import styles from '../styles/Footer.module.css';
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();
  const { lang } = useParams();

  return (
    <footer className={styles.footer}>

      <div className={styles.container}>
        <span className={styles.logo}>
          {t("footer.logo")}
        </span>
      </div>

      <div className={styles.container}>
        <div className={styles.contactInfo}>

          <a href="tel:+306955302366" className={styles.contactLink}>
            {t("footer.call")}: +30 695 530 2366
          </a>

          <a
            href="mailto:transferstoby@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.contactLink}
          >
            {t("footer.email")}: transferstoby@gmail.com
          </a>

          <span className={styles.contactText}>
            {t("footer.location")}: {t("footer.location_value")}
          </span>

        </div>
      </div>

      <div className={styles.container}>
        <div className={styles.social}>
          <a
            href="https://instagram.com/tobytransferscorfu"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.socialLink}
            aria-label="Instagram"
          >
            Instagram
          </a>

          <a
            href="https://www.facebook.com/profile.php?id=61573819934622"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.socialLink}
            aria-label="Facebook"
          >
            Facebook
          </a>
        </div>
      </div>

      <div className={styles.container}>
        <div className={styles.policies}>

          <NavLink to={`/${lang}/privacy`} className={styles.policyLink}>
            {t("footer.privacy")}
          </NavLink>

          <NavLink to={`/${lang}/cookie`} className={styles.policyLink}>
            {t("footer.cookies")}
          </NavLink>

        </div>
      </div>

      <span className={styles.copyright}>
        {t("footer.copyright")}{" "}
        <a
          href="https://cytechsharp.com.cy"
          target="_blank"
          rel="noopener noreferrer"
          title="Professional Website Development"
        >
          CyTechSharp
        </a>
      </span>

    </footer>
  );
}